// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TCSRelationshipType;
(function (TCSRelationshipType) {
    TCSRelationshipType[TCSRelationshipType["Parent"] = 0] = "Parent";
    TCSRelationshipType[TCSRelationshipType["LegalGuardian"] = 1] = "LegalGuardian";
    TCSRelationshipType[TCSRelationshipType["Other"] = 2] = "Other";
})(TCSRelationshipType || (TCSRelationshipType = {}));
//# sourceMappingURL=tCSRelationshipType.js.map